import * as React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Session } from '@supabase/supabase-js';
import IntakeForm from './components/IntakeForm';
import Confirmation from './pages/Confirmation';
import { supabase } from './utils/supabase';
import CustomAuth from './pages/Auth';
import DeckSuggestions from './pages/DeckSuggestions';
import { AppProvider } from './context/AppContext';
import { ModalProvider } from './context/ModalContext';
import PitchDeckTips from './components/PitchDeckTips';
import Landing from './pages/Landing';

function App() {
  const [session, setSession] = React.useState<Session | null>(null)

  React.useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
    })
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
    })
    return () => subscription.unsubscribe()
  }, [])
  return (
    !session ? (
      <ModalProvider>
      <CustomAuth />
      <PitchDeckTips />
      </ModalProvider>
    ) : (
      <AppProvider>
        <ModalProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Landing session={session} />} />
              <Route path="/confirmation" element={<Confirmation session={session} />} />
              <Route path="/deck_suggestions" element={<DeckSuggestions session={session} />} />
            </Routes>
            <IntakeForm session={session} />
            <PitchDeckTips />
          </Router>
        </ModalProvider>
      </AppProvider>
    )
  )
}

export default App;
